/**
 * CDB-TQS API — Wissenshaus (cdb_tqs#1905)
 */

import type { WissenshausDocumentResponse } from "@/types/wissenshaus";
import { CDB_TQS_API_BASE_URL, fetchWithLogging } from "./http";

export const wissenshausApi = {
  /**
   * What happened in the brain of one organisation, format `wissenshaus/1`.
   * @param clientId - Another organisation; admins only, defaults to the caller's own
   */
  async getHouse(clientId?: string): Promise<WissenshausDocumentResponse> {
    const response = await fetchWithLogging(`${CDB_TQS_API_BASE_URL}/wissenshaus`, {
      method: "GET",
      params: clientId ? { client_id: clientId } : undefined,
    });
    return response.data as WissenshausDocumentResponse;
  },
};
